<script>
import VectorLayer from 'ol/layer/Vector'
import { GeoJSON, WKT } from 'ol/format'
import VectorSource from 'ol/source/Vector'
import parseStyle from '../ol-map/utils/style'

function isString (str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

// 图形样式
const defaultEffect = {
  fill: 'rgba(90, 200, 33, 0.2)',
  stroke: {
    color: '#5ac821', // 绿色
    width: 2
  }
}

export default {
  name: 'ol-geom-polygon',

  inject: ['getMap'],

  render () {
    return null
  },

  props: {
    // 图层名称
    name: {
      type: String,
      default: ''
    },

    // 图层类型
    type: {
      type: String,
      default: ''
    },

    // 是否可见
    visible: {
      type: Boolean,
      default: true
    },

    // 透明度（0~1）
    opacity: {
      type: Number,
      default: 1
    },

    // 层级
    zIndex: {
      type: Number,
      default: undefined
    },

    features: {
      type: [Object, String],
      default: ''
    },

    // 图形样式
    effect: {
      type: [Object, Function],
      default () {
        return defaultEffect
      }
    }
  },

  watch: {
    visible (visible) {
      this.vectorLayer.setVisible(visible)
    },

    zIndex (zIndex) {
      this.vectorLayer.setZIndex(zIndex)
    },

    features (newVal) {
      const vectorSource = this.vectorLayer.getSource()
      vectorSource.clear()
      if (newVal === '') {
        return
      }
      const geoJson = new GeoJSON()
      if (isString(newVal)) {
        if (newVal.startsWith('{')) {
          // geojson 字符串
          const features = geoJson.readFeatures(newVal)
          // features.forEach(item => {
          //   item.setStyle(parseStyle({ ...defaultEffect, ...this.effect }))
          // })
          vectorSource.addFeatures(features)
        } else {
          // wkt 字符串
          const feature = new WKT().readFeature(newVal)
          // feature.setStyle(parseStyle({ ...defaultEffect, ...this.effect }))
          vectorSource.addFeature(feature)
        }
      } else {
        // const features = geoJson.readFeatures(newVal)
        // features.forEach(item => {
        //   // this.effect.text.text = item.get('name') || ''
        //   item.setStyle(parseStyle({ ...defaultEffect, ...this.effect }))
        // })
        vectorSource.addFeatures([newVal])
      }
    }
  },

  data () {
    return {
      vectorLayer: null
    }
  },

  created () {
    this.vectorLayer = new VectorLayer({
      name: this.name,
      type: this.type,
      visible: this.visible,
      zIndex: this.zIndex,
      opacity: this.opacity,
      style: parseStyle({ ...defaultEffect, ...this.effect }),
      source: new VectorSource()
    })

    this.getMap(map => {
      map.addLayer(this.vectorLayer)
    })
  },

  beforeDestroy () {
    this.vectorLayer = null
  }
}
</script>
